import {
  getAllVerticals,
  getVertical,
  getVerticalProviders,
  getPageList,
  getPage,
} from 'src/utils/contentful'

import VerticalIndex from '../../src/components/verticalIndex'
import PagePageIndex from '../../src/components/pagePageIndex'

function Page(props) {
  if (props?.isVertical) {
    return <VerticalIndex {...props} />
  }

  return <PagePageIndex {...props} />
}

export default Page

export async function getStaticPaths() {
  const verticals = await getAllVerticals()
  const pages = await getPageList()

  const verticalsSansIdentity = verticals.filter(
    (vertical) => vertical.slug !== 'identity',
  )

  const excludedPagePages = [
    'dashboard',
    'account',
    'apply',
    'careers',
    'careers-agents',
    'login',
    'privacy',
    'signup',
    'login',
    'terms',
    'verify',
    'identity',
    'partners',
  ]

  const pagesSansDashboard = pages.filter(
    (page) => !excludedPagePages?.includes?.(page.slug),
  )

  const verticalPostParams = verticalsSansIdentity.map((vertical) => ({
    params: { vertical: vertical.slug },
  }))

  const pagePagePostParams = pagesSansDashboard.map((page) => ({
    params: {
      vertical: page.slug,
    },
  }))

  return {
    paths: [...verticalPostParams, ...pagePagePostParams],
    fallback: false,
  }
}

export async function getStaticProps({ params }) {
  const verticals = await getAllVerticals()

  const verticalSlugs = verticals.reduce((slugs, vertical) => {
    if ('identity' !== vertical.slug) {
      return [...slugs, vertical.slug]
    }

    return slugs
  }, [])

  if (verticalSlugs?.includes?.(params.vertical)) {
    const vertical = await getVertical(params.vertical)
    const verticalProviders = await getVerticalProviders(params.vertical)

    if (!vertical) {
      return {
        notFound: true,
      }
    }

    return { props: { verticals, vertical, verticalProviders, isVertical: true } }
  }

  const page = await getPage(params.vertical)

  if (!page) {
    return {
      notFound: true,
    }
  }

  return { props: { verticals, slug: params.vertical, isVertical: false, page } }
}
